/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Which kind of MCP server this is.
 */
export const UserSessionIssuerMcpServerKind = {
  McpServer: "mcp_server",
  Toolset: "toolset",
  MetaMcpServer: "meta_mcp_server",
} as const;
/**
 * Which kind of MCP server this is.
 */
export type UserSessionIssuerMcpServerKind = OpenEnum<
  typeof UserSessionIssuerMcpServerKind
>;

/**
 * A live MCP server, toolset, or meta MCP server attached to a user_session_issuer.
 */
export type UserSessionIssuerMcpServer = {
  /**
   * The MCP server, toolset, or meta MCP server id.
   */
  id: string;
  /**
   * Which kind of MCP server this is.
   */
  kind: UserSessionIssuerMcpServerKind;
  /**
   * The display name.
   */
  name: string;
  /**
   * The owning project id.
   */
  projectId: string;
  /**
   * The owning project name.
   */
  projectName: string;
  /**
   * The MCP server or toolset slug. Absent for meta MCP servers and MCP servers without one.
   */
  slug?: string | undefined;
};

/** @internal */
export const UserSessionIssuerMcpServerKind$inboundSchema: z.ZodMiniType<
  UserSessionIssuerMcpServerKind,
  unknown
> = openEnums.inboundSchema(UserSessionIssuerMcpServerKind);

/** @internal */
export const UserSessionIssuerMcpServer$inboundSchema: z.ZodMiniType<
  UserSessionIssuerMcpServer,
  unknown
> = z.pipe(
  z.object({
    id: z.string(),
    kind: UserSessionIssuerMcpServerKind$inboundSchema,
    name: z.string(),
    project_id: z.string(),
    project_name: z.string(),
    slug: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "project_id": "projectId",
      "project_name": "projectName",
    });
  }),
);

export function userSessionIssuerMcpServerFromJSON(
  jsonString: string,
): SafeParseResult<UserSessionIssuerMcpServer, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UserSessionIssuerMcpServer$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UserSessionIssuerMcpServer' from JSON`,
  );
}
